/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Creator_Ext_Device_Disabled_ToastInputs */



/**
* | output |
* | --- |
* | "External device control disabled" |
*
* @param {Creator_Ext_Device_Disabled_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const creator_ext_device_disabled_toast = /** @type {((inputs?: Creator_Ext_Device_Disabled_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Creator_Ext_Device_Disabled_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Controle d'appareil externe desactive")
	if (locale === "de") return /** @type {LocalizedString} */ ("Externe Gerätesteuerung deaktiviert")
	if (locale === "it") return /** @type {LocalizedString} */ ("Controllo dispositivo esterno disabilitato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Управление внешним устройством отключено")
	if (locale === "es") return /** @type {LocalizedString} */ ("Control de dispositivo externo deshabilitado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("外部设备控制已禁用")
	if (locale === "ja") return /** @type {LocalizedString} */ ("外部デバイス制御が無効")
	if (locale === "hi") return /** @type {LocalizedString} */ ("बाह्य उपकरण नियंत्रण अक्षम")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Controle de dispositivo externo desativado")
	return /** @type {LocalizedString} */ ("External device control disabled")
});